import React, { Component } from 'react';

import { inject } from 'mobx-react';

class PurchaseErrorKabbalahone extends Component {
	
	handleClick = event => {
		event.preventDefault();		
		this.props.shopStore.purchaseError.set(null);		
	}

	render() {
		return (
			<div className="container">
				<div className="row">
					<div className="col-md-12 text-center">
						<div className="alert alert-danger" role="alert">
							An error has occurred.
						</div>					
						<p>
							Sorry! We encountered an error while trying to process your payment.
							Click below to try again.
						</p>
						<p>
							If you’ve tried more than once, please email care@kabbalahone.com or 
							call +1-888-898-8358.
						</p>
						{/*<p>
							Error message: {this.props.message}
						</p>*/}
					</div>
				</div>
				<hr />
				<div className="row">
					<div className="col-md-12 text-center">
						<a href="" onClick={this.handleClick}>
							<h5>&lt;&lt; Return to Billing Form</h5>
						</a>
					</div>
				</div>			  
			</div>
		);
	}
};

export default inject('shopStore')(PurchaseErrorKabbalahone);


// WEBPACK FOOTER //
// ./src/components/PurchaseErrorKabbalahone.js